module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "wrap"
    }
  }, [_c('header', {
    staticClass: "site-header header-one home-page-one",
    staticStyle: {
      "margin-top": "3em"
    }
  }, [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light header-navigation stricky"
  }, [_c('div', {
    staticClass: "container clearfix"
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_vm._m(0), _vm._v(" "), _c('span', {
    staticClass: "header-name"
  }, [_vm._v(_vm._s(_vm.sellpoint.business_name))])]), _vm._v(" "), (_vm.loggedIn) ? _c('div', {
    staticClass: "right-side-box"
  }, [(_vm.edit_mode) ? _c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Manage")]) : _c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Connect")])]) : _c('div', {
    staticClass: "right-side-box"
  }, [_c('a', {
    staticClass: "header-btn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('open')
      }
    }
  }, [_vm._v("Connect")])])])])]), _vm._v(" "), _c('div', {
    staticClass: "page-wrapper"
  }, [(_vm.sellpoint.business_banner_image != _vm.default_banner_image) ? _c('section', {
    staticClass: "banner-style-one home-page-two",
    staticStyle: {
      "margin-top": "-2em",
      "height": "100vh"
    },
    style: ({
      backgroundImage: 'linear-gradient(rgba(0, 0, 0, 0.78), rgba(0, 0, 0, 0.48)), url(' + _vm.img_sellpoint_url + _vm.sellpoint.business_banner_image + ')'
    }),
    attrs: {
      "id": "banner"
    }
  }, [_c('div', {
    staticClass: "container gw-container"
  }, [(_vm.business_load_error_msg != '') ? _c('div', {
    staticClass: "row content-block"
  }, [_c('p', {
    staticStyle: {
      "color": "#ffc107",
      "margin": "1em"
    }
  }, [_vm._v(_vm._s(_vm.business_load_error_msg))])]) : _c('div', {
    staticClass: "row content-block"
  }, [_c('div', {
    staticClass: "col-sm-6 gw-large"
  }, [_c('div', {
    staticStyle: {
      "display": "block",
      "margin-top": "8em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2)])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 gw-lookbook"
  }, [(_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs pull-right",
    staticStyle: {
      "background": "#f8ecf0",
      "color": "#161515",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.setComponent('refresh-store', '')
      }
    }
  }, [_vm._v("Refresh Lookbook")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "id": "addPanelView"
    }
  }, [(_vm.addPanel) ? _c('div', [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), (_vm.newLookbookForm) ? _c('div', [_c('add-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.newProductLookbookForm) ? _c('div', [_c('add-product-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.addNewPost) ? _c('div', {}, [_c('h6', [_vm._v("New Gallery Post")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e4abbe"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', [(_vm.loading) ? _c('div', [_vm._m(3)]) : _c('div', [_c('div', {
    staticClass: "row",
    staticStyle: {
      "height": "60vh",
      "overflow": "scroll"
    }
  }, _vm._l((_vm.galleria), function(gallery, gndex) {
    return _c('div', {
      staticClass: "folder-main col-6 col-md-4"
    }, [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_c('div', {
      staticClass: "folder-inner"
    }, [(gallery.gallery_posts_group_posts_media.length > 0) ? _c('div', {
      staticClass: "folder-inner-image"
    }, [(_vm.checkIfVideo(gallery.gallery_posts_group_posts_media[0].gallery_post_media)) ? _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/video-placeholder.png"
      }
    }) : _c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": gallery.gallery_posts_group_posts_media[0].gallery_post_media
      }
    })]) : _c('div', {
      staticClass: "folder-inner-image"
    }, [_c('img', {
      staticClass: "sp-prd-img",
      attrs: {
        "src": "/static/assets/images/dummy-image.png",
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "folder-inner-words"
    }, [_c('h5', [_c('a', {
      on: {
        "click": function($event) {
          _vm.getPostsInGallery(gallery)
        }
      }
    }, [_vm._v(_vm._s(gallery.gallery_posts_group_name))])])])])])])
  })), _vm._v(" "), (_vm.edit_mode && _vm.can_add_more_lookbook) ? _c('div', {
    staticClass: "row",
    staticStyle: {
      "display": "none"
    }
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "folder-main col-6 col-md-4"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-lookbook', '')
      }
    }
  }, [_vm._m(4)])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode && _vm.can_add_product_lookbook) ? _c('div', {
    staticClass: "folder-main col-6 col-md-4"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-lookbook', '')
      }
    }
  }, [_vm._m(5)])]) : _vm._e()]) : _vm._e()])]), _vm._v(" "), _vm._m(6)])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "sidenav",
    attrs: {
      "id": "mobileSideNav"
    }
  }, [_c('a', {
    staticClass: "closebtn",
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": function($event) {
        _vm.mobileSideNavToggle('close')
      }
    }
  }, [_vm._v("×")]), _vm._v(" "), _c('div', {
    staticClass: "container sidenav-links"
  }, [_c('ul', [_vm._m(7), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    attrs: {
      "href": "account"
    }
  }, [_vm._v("My Account")])]) : _c('li', [_c('a', {
    attrs: {
      "href": "login"
    }
  }, [_vm._v("Login")])]), _vm._v(" "), (_vm.loggedIn) ? _c('li', [_c('a', {
    staticStyle: {
      "cursor": "pointer"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("Go to Sellpoint")])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "container sidenav-container"
  }, [_c('div', {
    staticStyle: {
      "margin-right": "2em"
    }
  }, [(_vm.addPanel) ? _c('div', {
    attrs: {
      "id": "addPanelView"
    }
  }, [(_vm.addPanel) ? _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "5px"
    }
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "float": "right",
      "background": "#ff0055",
      "color": "#ffffff",
      "margin-bottom": "1em"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.reset
    }
  }, [_vm._v("Cancel")]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (_vm.newLookbookForm) ? _c('div', [_c('add-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.newProductLookbookForm) ? _c('div', [_c('add-product-lookbook')], 1) : _vm._e(), _vm._v(" "), (_vm.addNewPost) ? _c('div', {}, [_c('h6', [_vm._v("Add a new Post to "), _c('b', [_vm._v(_vm._s(_vm.gallery.gallery_posts_group_name))])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('form', {
    staticClass: "gw-form"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Caption")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_caption),
      expression: "post.post_caption"
    }],
    attrs: {
      "type": "text",
      "value": "",
      "placeholder": ""
    },
    domProps: {
      "value": (_vm.post.post_caption)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_caption = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v(" *Details")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.post.post_details),
      expression: "post.post_details"
    }],
    domProps: {
      "value": (_vm.post.post_details)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.post.post_details = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('div', {
    staticClass: "upload-btn-wrapper",
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_c('button', {
    staticClass: "upload-btn",
    attrs: {
      "type": "button"
    }
  }, [_vm._v("Add Image")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "file",
      "id": "input-file",
      "accept": "image/*"
    },
    on: {
      "change": function($event) {
        _vm.onFileChange($event)
      }
    }
  }), _vm._v(" "), (_vm.file_info[0]) ? _c('span', [_c('b', [_vm._v("Added " + _vm._s(_vm.file_info[0].name))])]) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#e4abbe"
    }
  }, [_vm._v(_vm._s(_vm.data_success_message))]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addPostToGallery
    }
  }, [_vm._v("Add")])])])]) : _vm._e()]) : _vm._e()]) : _c('div', [_c('div', {
    staticStyle: {
      "margin-right": "2em"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(" "), _c('div', {
    staticClass: "sidenav-banner-img"
  }, [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": _vm.sellpoint.business_banner_image
    }
  })]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })]), _vm._v(" "), (!_vm.edit_mode) ? _c('div', {
    staticStyle: {
      "margin-top": "1em"
    }
  }, [_c('h5', [_vm._v("Contact Us")]), _vm._v(" "), _vm._m(8), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  })]) : _vm._e(), _vm._v(" "), (_vm.edit_mode) ? _c('div', {}, [_c('p', [_vm._v("Welcome "), _c('b', [_vm._v(_vm._s(_vm.sellpoint.business_name))]), _vm._v(", here you can set up and manage your gallery with any of these actions below")]), _vm._v(" "), (_vm.edit_mode && _vm.can_add_more_lookbook) ? _c('div', {
    staticClass: "row"
  }, [(_vm.edit_mode) ? _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_c('div', {
    staticClass: "gw-add-btn"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-lookbook', '')
      }
    }
  }, [_c('h5', [_vm._v("Add New Lookbook")])])])]) : _vm._e(), _vm._v(" "), (_vm.edit_mode && _vm.can_add_product_lookbook) ? _c('div', {
    staticClass: "col-6 col-md-4"
  }, [_c('div', {
    staticClass: "gw-add-btn"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-lookbook', '')
      }
    }
  }, [_c('h5', [_vm._v("Add Product Lookbook")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [(!(_vm.edit_mode && _vm.can_add_more_lookbook)) ? _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_c('h5', [_vm._v("You have reached the limit of your gallery")]), _vm._v(" "), _vm._m(9)])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 col-sm-12",
    staticStyle: {
      "margin": "0",
      "padding": "0"
    }
  }, [_c('div', {
    staticClass: "manage-action-block"
  }, [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "inherit"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_c('h5', [_vm._v("Manage Your Gallery on Sellpoint")]), _vm._v(" "), _c('p', [_vm._v("Once clicked you would be directed to your Sellpoint account to further set-up your page")]), _vm._v(" "), _c('button', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("Manage")])])])])])]) : _vm._e()])])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade modal-c p-modal",
    attrs: {
      "id": "quickviewModal",
      "role": "dialog"
    }
  }, [_c('div', {
    staticClass: "modal-dialog"
  }, [(_vm.place_order) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('button', {
    staticClass: "pul-right close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    },
    on: {
      "click": _vm.resetOptions
    }
  }, [_c('b', [_vm._v("close")])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row row-20 mb-20 mb-xs-0"
  }, [(_vm.payment_successful) ? _c('div', {
    staticClass: "col-xs-12 mb-40"
  }, [_c('h3', {
    staticStyle: {
      "line-height": "1.6"
    }
  }, [_vm._v(_vm._s(this.payment_successful_message))])]) : _c('div', {
    staticClass: "col-xs-12 mb-40"
  }, [_c('h4', [_vm._v("Place Order For "), _c('b', [_vm._v(_vm._s(_vm.ordered_product.product_name) + "(₦" + _vm._s(_vm.ordered_product_item.product_item_price) + ")")])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "color": "#ff0000"
    }
  }, [_vm._v(_vm._s(_vm.data_error_message))]), _vm._v(" "), _c('div', {}, [_c('form', [_c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_name),
      expression: "payment_payer_name"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text",
      "placeholder": "Name"
    },
    domProps: {
      "value": (_vm.payment_payer_name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_email),
      expression: "payment_payer_email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "email",
      "placeholder": "Email"
    },
    domProps: {
      "value": (_vm.payment_payer_email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.payment_payer_phone),
      expression: "payment_payer_phone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "number",
      "placeholder": "Phone (format: 09088776655)"
    },
    domProps: {
      "value": (_vm.payment_payer_phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.payment_payer_phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _vm._m(10), _vm._v(" "), _c('br'), _vm._v(" "), _c('a', {
    staticClass: "btn pull-left",
    staticStyle: {
      "cursor": "pointer",
      "border-radius": "2px",
      "background": "#ffc107",
      "color": "#000"
    },
    on: {
      "click": function($event) {
        _vm.processPayment()
      }
    }
  }, [_vm._v(" Proceed")])])])])])])]) : _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-body",
    staticStyle: {
      "margin-top": "2em"
    }
  }, [(_vm.edit_mode) ? _c('button', {
    staticClass: "btn btn-xs pull-left",
    staticStyle: {
      "background": "#f8ecf0",
      "color": "#161515",
      "margin-bottom": "1em"
    },
    attrs: {
      "disabled": _vm.disable_btn,
      "type": "button"
    },
    on: {
      "click": _vm.manageLookbook
    }
  }, [_vm._v("ManageLookbook")]) : _vm._e(), _vm._v(" "), _vm._m(11), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), (_vm.edit_mode) ? _c('div', [(_vm.gallery.gallery_posts_group_posts_total < _vm.max_plan_lookbook_posts) ? _c('div', [_c('p', {
    staticStyle: {
      "color": "#ff0055"
    }
  }, [_vm._v("Add new Post to " + _vm._s(_vm.gallery.gallery_posts_group_name) + ", \r\n                                    "), (((_vm.gallery.gallery_posts_group_type == 2) && _vm.can_add_product_lookbook)) ? _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "background": "#ffc107",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-product-post', _vm.gallery)
      }
    }
  }, [_vm._v("Add")]) : _c('a', {
    staticStyle: {
      "cursor": "pointer",
      "background": "#ffc107",
      "padding": "5px"
    },
    on: {
      "click": function($event) {
        _vm.addComponent('add-new-post', _vm.gallery)
      }
    }
  }, [_vm._v("Add")])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('h2', {
    staticStyle: {
      "font-size": "28px"
    }
  }, [_vm._v(_vm._s(_vm.gallery_post.gallery_post_caption) + "\r\n                                                "), (_vm.gallery_post.gallery_post_product_items) ? _c('span', [_vm._v("(₦" + _vm._s(_vm.gallery_post.gallery_post_product_items[0].product_item_price) + ")")]) : _vm._e()]), _vm._v(" "), (_vm.gallery_post_set_image.gallery_post_media != '') ? _c('div', {
    staticClass: "image",
    staticStyle: {
      "height": "250px",
      "width": "100%"
    }
  }, [(_vm.checkIfVideo(_vm.gallery_post_set_image.gallery_post_media)) ? _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": "/static/assets/images/video-placeholder.png",
      "alt": ""
    }
  }) : _c('img', {
    staticClass: "rounded",
    staticStyle: {
      "width": "100%",
      "height": "100%",
      "object-fit": "contain"
    },
    attrs: {
      "src": _vm.gallery_post_set_image.gallery_post_media,
      "alt": ""
    }
  }), _vm._v(" "), (_vm.gallery_post.gallery_post_media) ? _c('div', {
    staticClass: "image-overlay",
    staticStyle: {
      "top": "80px"
    }
  }, [(_vm.gallery_post.gallery_post_media.length > 1) ? _c('ul', {
    staticClass: "food-menu-list-num"
  }, _vm._l((_vm.gallery_post.gallery_post_media), function(img, imdex) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPostImage(img)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-circle-o"
    })])])
  })) : _vm._e()]) : _vm._e()]) : _c('div', [_c('img', {
    staticClass: "sp-prd-img",
    attrs: {
      "src": "/static/assets/images/dummy-image.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "content",
    staticStyle: {
      "top": "200px"
    }
  }, [_c('div', {
    staticClass: "content-left"
  }), _vm._v(" "), _c('div', {
    staticClass: "content-right"
  }, [_c('p', [_vm._v(_vm._s(_vm.gallery_post.gallery_post_details))])])])]), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('hr')]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [(_vm.gallery.gallery_posts_group_posts) ? _c('div', {
    staticClass: "col-xs-12 mb-40 pull-right"
  }, [(_vm.gallery.gallery_posts_group_posts.length > 1) ? _c('ol', {
    staticClass: "food-menu-list-num"
  }, _vm._l((_vm.gallery.gallery_posts_group_posts), function(post, prdex) {
    return _c('li', [_c('a', {
      staticStyle: {
        "cursor": "pointer"
      },
      on: {
        "click": function($event) {
          _vm.showPost(post)
        }
      }
    }, [_vm._v(_vm._s(++prdex))])])
  })) : _vm._e()]) : _vm._e()])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logo-sm.png",
      "alt": "Awesome Image"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Contact Us")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "margin": "6em"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/loader.gif"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-inner"
  }, [_c('div', {
    staticClass: "folder-inner-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "6px",
      "font-size": "24px",
      "color": "#ff0055"
    }
  }, [_vm._v("Add New Lookbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "folder-inner"
  }, [_c('div', {
    staticClass: "folder-inner-image",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h2', {
    staticStyle: {
      "padding": "6px",
      "font-size": "24px",
      "color": "#ff0055"
    }
  }, [_vm._v("Add New Product Lookbook")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "gw-mobile",
    staticStyle: {
      "display": "none"
    }
  }, [_c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")]), _vm._v(" "), _c('div', {
    staticClass: "button-block"
  }, [_c('a', {
    staticClass: "banner-btn",
    attrs: {
      "href": "#"
    }
  }, [_c('span', [_vm._v("Contact Us")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Home")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("Capture your moments "), _c('br'), _vm._v(" save and organise and "), _c('br'), _vm._v(" make your work roll out like a gallery.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("To add more lookboks to your gallery, "), _c('a', {
    staticClass: "btn",
    staticStyle: {
      "background": "#ff0055",
      "color": "#ffffff"
    },
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Upgrade your Account")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group"
  }, [_c('input', {
    attrs: {
      "type": "checkbox",
      "checked": "true",
      "disabled": "disabled"
    }
  }), _vm._v(" By proceeding, you agree with the "), _c('u', [_c('a', {
    staticStyle: {
      "cursor": "pointer",
      "color": "#ff0055",
      "font-weight": "bold"
    },
    attrs: {
      "data-toggle": "modal",
      "data-backdrop": "false",
      "data-target": "#terms-modal",
      "href": "#"
    }
  }, [_vm._v("Terms and Conditions")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "pull-right close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_c('b', [_vm._v("close")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a9c940e"}!./src/pages/Demos/template.html
// module id = 511
// module chunks = 0